import { Component } from '@angular/core';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { PanelType } from 'src/app/panels/models/panel-type';
import { Color } from 'src/app/shared/services/color/colors';
import {
  KPI_PANEL_IMPORTS,
  KpiPanelComponent,
} from '../../../../../panels/components/kpi/kpi-panel/kpi-panel.component';
import { PanelComponent } from '../../../../../panels/components/panel.component';

@PanelComponent.register
@Component({
  templateUrl: '../../../../../panels/components/kpi/kpi-panel/kpi-panel.component.html',
  styleUrl: '../../../../../panels/components/kpi/kpi-panel/kpi-panel.component.scss',
  selector: 'app-cost-gas-kpi-panel',
  imports: KPI_PANEL_IMPORTS,
})
export class CostGasKpiPanelComponent extends KpiPanelComponent {
  public static override readonly type = PanelType.CostGasKpi;
  public override title = 'Gas kosten';
  public override icon = 'bi-cash';
  public override unit = DisplayUnit.Euro;
  public override color = Color.Yellow;
}
